import React from 'react';

export interface PillBackgroundProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: React.CSSProperties['width'];
  minHeight?: React.CSSProperties['minHeight'];
  fill?: string;
  children?: React.ReactNode;
}

export const PillBackground: React.FC<PillBackgroundProps> = ({
  width = '100%',
  minHeight = '72px',
  fill,
  children,
  className = '',
  style,
  ...rest
}) => {
  const pillVarStyle = fill ? ({ '--exercise-pill-bg': fill } as React.CSSProperties) : {};

  return (
    <div
      className={`pill-bg-wrapper ${className}`.trim()}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width,
        minHeight,
        ...pillVarStyle,
        ...style,
      }}
      {...rest}
    >
      <svg
        viewBox="0 0 510 108"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          display: 'block',
        }}
      >
        <path
          className="pill-bg-path"
          d="M439.707 0C457.071 0 472.52 8.196 482.398 20.9297C498.608 26.3308 510 39.1028 510 54C510 68.8966 498.608 81.667 482.399 87.0684C472.521 99.803 457.072 108 439.707 108H70.8975C53.653 108 38.2956 99.9172 28.4092 87.333C11.7719 82.0918 0.00025108 69.1432 0 54C0 38.8562 11.7721 25.906 28.4102 20.665C38.2966 8.08186 53.6537 0 70.8975 0H439.707Z"
        />
      </svg>

      <div
        style={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          padding: '0 2rem',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </div>
    </div>
  );
};

